// Переключатель дизайна: classic (по умолчанию) / cp. Старая версия — vehicle-class.styled.classic.js, новая — vehicle-class.styled.cp.js
import { isCp } from 'libs/design';
import * as classic from './vehicle-class.styled.classic';
import * as cp from './vehicle-class.styled.cp';

export const Button = isCp ? cp.Button : classic.Button;
export const Content = isCp ? cp.Content : classic.Content;
export const Label = isCp ? cp.Label : classic.Label;
